import * as React from "react";
import { Form, Input, Row, Col, Select } from "antd";
import { FormattedMessage } from "react-intl";
import { createRequest, updateRequest } from "@actions/province";
import { Province } from "@models/province";
import { Resource } from "@models/resource";
import withFormWrapper from "../../hocs/withFormWrapper";

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  userRole?: Province;
  resource_ids: [];
  is_fetched_resources: boolean;
  resources: Resource[];
}

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
}

type ProvinceFormStateShape = {
  visible: boolean;
  name: string;
  id : string
};

type ProvinceFormAllProps = PropsFromState & PropsFromDispatch;

class ProvinceForm extends React.Component<
  ProvinceFormAllProps,
  ProvinceFormStateShape
> {
  constructor(props) {
    super(props);

    const { province } = props;
    this.state = {
      ...this.getStateFromProps(province)
    };
  }

  getStateFromProps = (province: Province | null = {}) => {
    const obj = province || {};
    return {
      visible: false,
      name: obj.name || "",
      id: obj.id || null
    };
  };

  /**
   * Set cover and avatar ids in a form values to handle validation by form
   */
  getValues = () => {
    let returnValues: any = null;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values
        };
      }
    });

    return {
      payload: returnValues,
      id: this.state.id
    };
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label={<FormattedMessage id="app.name" defaultMessage={`Name`} />}
            >
              {getFieldDecorator("name", {
                initialValue: this.state.name,
                rules: [
                  {
                    whitespace: true,
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.name_is_required"
                        defaultMessage={`Name is required!`}
                      />
                    )
                  }
                ]
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
}

const WrappedProvinceForm = Form.create({ name: "province-form" })(
  ProvinceForm
);
export default withFormWrapper(WrappedProvinceForm);
